import type { Href } from "expo-router"
import { useRouter } from "expo-router"
import { useTranslation } from "react-i18next"
import { StyleSheet } from "react-native"

import { AppText, Button, Card, Column, Theme, TitleWithIcon } from "@/theme"
import i18n from "@/translations/i18n"

import type { CardProps } from "@/theme"
import type React from "react"

export function PermissionDeniedFallback({
  backHref,
  messageText,
  onPressBack,
  style,
  titleText,
}: {
  backHref?: Href
  messageText?: string
  onPressBack?: () => void
  style?: CardProps["style"]
  titleText?: string
}) {
  const router = useRouter()
  const { t } = useTranslation("farmUserPermissions")
  let handlePressBack = onPressBack
  if (!handlePressBack) {
    if (typeof backHref !== "undefined") {
      handlePressBack = () => router.navigate(backHref)
    } else if (router.canGoBack()) {
      handlePressBack = () => router.back()
    } else if (router.canDismiss()) {
      handlePressBack = () => router.dismiss()
    }
  }

  return (
    <Card maxW={"$2xl"} mx={"auto"} style={style}>
      <Column space={"$4"}>
        <TitleWithIcon
          IconComponent={"Warning"}
          mb={"$4"}
          titleText={titleText ?? t("permissionDenied")}
        />
        <AppText style={styles.text}>
          {messageText ?? t("youDoNotHavePermissionToAccessThisResource")}
        </AppText>
        {handlePressBack ? (
          <Button
            text={i18n.t("back")}
            variant={"text"}
            onPress={handlePressBack}
          />
        ) : null}
      </Column>
    </Card>
  )
}
const styles = StyleSheet.create({
  text: {
    marginBottom: Theme.SPACING.$4,
  },
})
